import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import DataSummarySection from './DataSummarySection';
import DataTableSection from './DataTableSection';

import { 
  DATA_SUMMARY_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  DATA_SUMMARY_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/DataSummaryModali18nConstants';


class DataSummaryModal extends Component {
  static propTypes = {
    show:                                                    PropTypes.bool.isRequired,
    toggleModal:                                             PropTypes.func.isRequired,
    fileInfoAfterValidation:                                 PropTypes.object.isRequired,
    clearUploadedFileAndReturnToUploadFilesOrEditTopicModal: PropTypes.func.isRequired,
    postUploadedFile:                                        PropTypes.func.isRequired,
    cleanedFileData:                                         PropTypes.array.isRequired,
    totalDataPointsForUploadedFile:                          PropTypes.number.isRequired,
    handleUserInputDateForUploadedComments:                  PropTypes.func.isRequired,
    handleUserInputLanguageForUploadedComments:              PropTypes.func.isRequired
  };

  componentDidMount() {
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }


  render() {
    const {
      toggleModal,
      show,
      fileInfoAfterValidation,
      clearUploadedFileAndReturnToUploadFilesOrEditTopicModal,
      postUploadedFile,
      cleanedFileData,
      totalDataPointsForUploadedFile
    } = this.props;


    return (
      <div className={`modal create-upload-data-topic-modal data-summary-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
          <div className="modal-content"> 
              <div className="modal-header">
                    <span className="create-upload-data-topic-modal-title">
                        {this.getI18nText(MY_I18N_KEYS.modal_title)}
                    </span>
                <button
                  onClick={() => toggleModal(false)}
                  onKeyDown={() => {}}
                >
                  <i className="la la-close modal-close"/>    
                </button>
              </div>
            <DataSummarySection
              fileInfoAfterValidation={fileInfoAfterValidation}
              totalDataPointsForUploadedFile={totalDataPointsForUploadedFile}
              includeMissingValue={false}
              handleUserInputDateForUploadedComments={e => this.props.handleUserInputDateForUploadedComments(e)}
              handleUserInputLanguageForUploadedComments={e => this.props.handleUserInputLanguageForUploadedComments(e)}
              displayLanguageSelection={true}
            />
            <DataTableSection
              cleanedFileData={cleanedFileData}
            />
            <div className="modal-footer">
              <button
                type="button"
                className='btn variable-width-btn'
                onClick={() => clearUploadedFileAndReturnToUploadFilesOrEditTopicModal()}
              >
                {this.getI18nText(MY_I18N_KEYS.select_another_file_button_text)}
              </button>
              <button
                type="submit"
                className='btn btn-submit variable-width-btn'
                onClick={() => postUploadedFile()}
              >
                {this.getI18nText(MY_I18N_KEYS.confirm_file_button_text)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DataSummaryModal;


// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/DataSummaryModal.js